/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { formatCostCenterFinderOptionLabel } from '@gh/common-internal-shared';
import { State } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { Observable } from 'rxjs';
import { HpeCostCenter, isHpeComponentCostCenter } from '../../../resources/hpe-details.model';
import { HpeCommandService } from '../hpe-command.service';
import {
  HpeDetailsState,
  queryHpeCostCenters,
  queryHpeEditable,
  queryHpeSelectedCostCenterId,
} from '../hpe-details.state';
import { HpeDetailsCcGridDefinition } from './hpe-details-cc-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-hpe-details-cc-list',
  templateUrl: 'hpe-details-cc-list.component.html',
  styleUrls: ['hpe-details-cc-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HpeDetailsCcGridDefinition],
})
export class HpeDetailsCcListComponent implements OnInit {
  readonly costCenterGridFinderDisplayWith = formatCostCenterFinderOptionLabel;

  editable: boolean = true;
  costCenters$: Observable<HpeCostCenter[]>;
  selectedCostCenterId$: Observable<Maybe<ID>>;

  constructor(public gridDefinition: HpeDetailsCcGridDefinition,
              private state: State<HpeDetailsState>,
              private commands: HpeCommandService) {

  }

  ngOnInit(): void {
    this.costCenters$ = this.state.select(queryHpeCostCenters);
    this.selectedCostCenterId$ = this.state.select(queryHpeSelectedCostCenterId);
    this.editable = this.state.project(queryHpeEditable);
  }

  onAdd(): void {
    this.commands.costCenterAdd();
  }

  onViewOrderDetails(costCenter: HpeCostCenter): void {
    this.commands.costCenterViewOrderDetails(costCenter);
  }

  onDelete(costCenter: HpeCostCenter): void {
    this.commands.costCenterRemove(costCenter);
  }

  canBeRemoved(costCenter: HpeCostCenter): boolean {
    return costCenter.count === 0;
  }

  isTypicalCc(costCenter: HpeCostCenter): boolean {
    return !isHpeComponentCostCenter(costCenter);
  }

  onSelectedCostCenterChanged(id?: ID): void {
    this.commands.costCenterSelect(id);
  }
}
